<template>
    <div style="display: flex;flex-direction: column;height: 100%;width: 100%;position: absolute;top: 0;left: 0;">
        <transition name="el-zoom-in-bottom">
            <div v-if="shoppingCartInfo.total > 0"
                style=" box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1);display: flex;align-items: center;width: 100%;height: 60px;position: fixed;bottom: 0;background: white;left: 0;z-index: 101;justify-content: space-between;">
                <img src="../assets/外卖员.png" style="width: 80px;position: absolute;bottom: 0;left: 0;" alt="">
                <div
                    style="display: flex;flex-direction: column;margin-left: 90px;align-items: flex-start;color: #EA9518;">
                    <div style="font-weight: 700;font-size: large;">到手约¥{{ shoppingCartInfo.total }}</div>
                    <div style="font-size: small;color: black;">另需配送费¥{{ }}</div>
                </div>
                <div @click="submitNewOrder" style="padding: 10px;background: #EA9518;margin-right: 10px;color: white;">
                    去结算</div>
            </div>
        </transition>


        <div :style="{ height: contentHeight + 'px' }" style="width: 100%;overflow: auto;  scrollbar-width: none;
  -ms-overflow-style: none;display: flex;align-items: center; ">
            <div class="columnformat" id="columnformat" style="">
                <div style="width: 100%;display: flex;flex-direction: column;align-items: center;"
                    v-if="companyDetail && companyDetail.storeHeaderImage">
                    <el-carousel height="200px" style="width: 100%;" indicator-position="none" :loop="true"
                        :interval="10000">
                        <el-carousel-item v-for="item in companyDetail.storeHeaderImage.split(';')" :key="item">
                            <img :src="resourceBase + '/assets/companyImg/' + item"
                                style="width: 100%;height: 100%;object-fit: cover;" alt="">
                        </el-carousel-item>
                    </el-carousel>
                    <div style="border-radius: 10px 10px 0 0;width: calc(100% - 20px);display: flex;flex-direction: column;align-items: center;position: absolute;top: 180px;z-index: 100;background: #FAFBFD;padding: 0 10px;"
                        :style="{ height: contentHeight - 180 + 'px' }">
                        <div
                            style="border-radius:10px;padding: 10px 0;width: 100%;display: flex;flex-direction: column;align-items: center;background: white;">
                            <div
                                style="display: flex;justify-content: space-between;align-items: center;width: calc(100% - 4px);">
                                <div style="text-align: left;font-size: x-large;font-weight: 700;">
                                    {{ companyDetail.companyName }}
                                </div>
                                <img @click="createChatRomm" src="../assets/对话.png"
                                    style="width: 20px;height: 20px;margin-right: 10px;" alt="">
                            </div>

                            <div
                                style="display: flex;align-items: center;width: calc(100% - 4px);justify-content: space-between;border-bottom: solid 1px grey;padding: 10px 0;">
                                <div style="display: flex;align-items: center;background: #FFF8E1;">
                                    <div
                                        style="background: #FF5648;color: white;width: 30px;border-radius: 5px 0 5px 5px;">
                                        {{
                                            companyDetail.rating }}</div>
                                    <el-rate v-model="companyDetail.rating" :colors="colors">
                                    </el-rate>
                                </div>
                                <div v-if="companyDetail.businessScope !== ''"
                                    style="display: flex;justify-content: flex-end;align-items: center;width: 200px;overflow: auto; -ms-overflow-style: none; scrollbar-width: none;">
                                    <div v-for="businessScope, businessIndex in companyDetail.businessScope.split(';')"
                                        :key="businessIndex"
                                        style="margin-right: 10px;background: #f0f0f0;color: #333;padding: 2px 5px;border-radius: 3px;font-size: small;flex-shrink: 0;">
                                        {{ businessScope }}
                                    </div>
                                </div>

                            </div>
                            <div style="width: calc(100% - 4px);display: flex;padding: 5px 0;">
                                <div style="font-weight: 700;">商家地址:</div>
                                <!-- <div style="flex: 1;text-align: left;margin-left: 10px;">{{ selectedAddress == null ? "" :
                                    selectedAddress.location }}
                                </div> -->
                                <div style="flex: 1;text-align: left;margin-left: 10px;">{{
                                    companyDetail.completeAddress }}
                                </div>
                            </div>
                        </div>

                        <div id="ComponentItemList"
                            style="width: calc(100% - 4px);text-align: left;font-size: large;font-weight: 700;background: #FAFBFD;padding: 10px 0;">
                            商品
                        </div>

                        <div style="width: calc(100% - 4px);" :style="{
                            height: CompanyItemHeight + 'px'
                        }">
                            <component style="width: 100%;height: 100%;" :style="{
                                height: CompanyItemHeight + 'px'
                            }" :is="currentComponent" :companyId="serverId" :companyType="companyDetail.type"
                                :shoppingCartInfo="shoppingCartInfo" @addItemInShoppingCart="addItemInShoppingCart"
                                @delItemInShoppingCart="delItemInShoppingCart">
                            </component>

                        </div>
                        <div v-if="companyDetail.type >= 9"
                            style="width: calc(100% - 4px);display: flex;flex-direction: column;">
                            <div style="margin: 5px 0;width: 100%;text-align: left;font-size: large;font-weight: 700;">
                                业务员</div>
                            <div
                                style="width: 100%;background: white;display: flex;overflow: auto; -ms-overflow-style: none; scrollbar-width: none;">
                                <div style="display: flex;flex-direction: column;margin: 10px;">
                                    <img :src="resourceBase + '/assets/serverImg/' + '1_s.png'"
                                        style="width: 80px;height: 80px;object-fit: cover;" alt="">
                                    <div style="width: 100%;text-align: left;font-weight: 700;">{{ '冯艳' }}</div>
                                    <div style="width: 100%;text-align: left;">{{ '资深美容师' }}</div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>


            </div>
        </div>
         <div style="width: 100%;margin: 20px 0;" :style="{
            height: $store.state.indexBarHeight+10 + 'px'
        }">
            <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号</a>
            <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026080515号-2</a>
        </div>
    </div>

</template>

<style scoped>
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}

.columnformat {

    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: green;
    overflow: auto;
}

body {
    margin: 0;
}
</style>

<script>
import request from "@/axios/request";
import CompanyItemListView from "@/views/CompanyItemListView.vue";

export default {
    components: {
        CompanyItemListView
    },
    data() {
        return {
            contentHeight: null,
            resourceIp: null,
            resourceBase: /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname) ? 'https://yuanhuihuanhuan.com' : window.location.origin,
            companyDetail: null,
            serverId: null,
            colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
            activeName: 'good',
            currentComponent: 'CompanyItemListView',
            serversList: [],
            CompanyItemHeight: null,
            selectedAddress: null,
            shoppingCartInfo: {
                itemInfoList: new Map(),
                itemDetailMap: new Map(),
                total: 0,
                deliveryFee: 0,
                totalNum:0
            }
        }
    },

    async mounted() {
        this.selectedAddress = JSON.parse(localStorage.getItem("selectedAddress"))

        this.serverId = this.$route.params.serverId;
        await this.getCompanyDetailByCompanyId()
        this.getCompanyServers()
        this.calculateDistance()
        const resizeObserver = new ResizeObserver((entries) => {
            requestAnimationFrame(() => {
                for (const entry of entries) {

                    const myconpoment = document.getElementById("ComponentItemList")
                    this.contentHeight = window.innerHeight
                    if (myconpoment != null) {
                        this.CompanyItemHeight = this.contentHeight - myconpoment.getBoundingClientRect().height
                    }


                }
            });
        });
        resizeObserver.observe(document.getElementById("columnformat"));
        this.resourceIp = this.extractIPFromURL(window.location.origin);

    },
    methods: {
        async calculateDistance() {
          
            let res = await request({
                url:"/company/api/calculateDeliveryFee?companyLat="+this.companyDetail.lat+"&companyLng="+this.companyDetail.lng+"&myLat="+this.selectedAddress.lat+"&myLng="+this.selectedAddress.lng,
                method:"get"
            })
            if (res.data.status == 200) {
                console.log(res.data.data);
                
            }



        },
        async submitNewOrder() {
            if (this.selectedAddress == null) {
                 this.$message.error('请添加默认地址');
                 this.$router.push({
                    path:"/address"
                 })
                 return
            }
           
            const itemArray = [];
            this.shoppingCartInfo.itemInfoList.forEach((quantity, itemId) => {
                if (quantity > 0) {
                    itemArray.push({
                        itemId: itemId,
                        quantity: quantity
                    });
                }
            });

            if (this.submittingOrder) return
            this.submittingOrder = true
            try {
                const res = await request({ url: '/order/api/createServerOrder', method: 'POST', data: {
                    companyId: this.serverId, addressId: this.selectedAddress.id, itemList: itemArray, serviceMode: 0
                } })
                if (res.data.status === 200) this.$router.push({ path: '/OrderInfoView/' + res.data.data })
            } finally { this.submittingOrder = false }
        },
        addItemInShoppingCart(itemInfo) {
            const itemId = itemInfo.id
            const price = itemInfo.price
            this.shoppingCartInfo.itemDetailMap.set(itemId, itemInfo.item || itemInfo)
            const itemNum = this.shoppingCartInfo.itemInfoList.get(itemId)
            if (itemNum == null) {
                this.shoppingCartInfo.itemInfoList.set(itemId, 1)
            } else {
                this.shoppingCartInfo.itemInfoList.set(itemId, itemNum + 1)
            }
            this.shoppingCartInfo.total += price
            this.shoppingCartInfo.totalNum += 1
            this.shoppingCartInfo = {
                itemInfoList: this.shoppingCartInfo.itemInfoList,
                itemDetailMap: this.shoppingCartInfo.itemDetailMap,
                total: this.shoppingCartInfo.total,
                totalNum:this.shoppingCartInfo.totalNum
            }
        },
        delItemInShoppingCart(itemInfo) {
            const itemId = itemInfo.id
            const price = itemInfo.price
            const itemNum = this.shoppingCartInfo.itemInfoList.get(itemId)
            if (itemNum == null || itemNum <= 0) {
                return
            } else {
                this.shoppingCartInfo.itemInfoList.set(itemId, itemNum - 1)
            }
            this.shoppingCartInfo.total -= price
            this.shoppingCartInfo.totalNum -= 1
            this.shoppingCartInfo = {
                itemInfoList: this.shoppingCartInfo.itemInfoList,
                itemDetailMap: this.shoppingCartInfo.itemDetailMap,
                total: this.shoppingCartInfo.total,
                totalNum:this.shoppingCartInfo.totalNum
            }
        },
        async createChatRomm() {

            let res = await request({
                url: "/chat/api/createChatRoom",
                method: "POST",
                data: {
                    userId: JSON.parse(localStorage.getItem("userInfo")).id,
                    companyId: this.serverId
                }
            })
            if (res.data.status == 200) {
                this.$router.push({
                    path: '/message/' + res.data.data 
                });
            }
        },
        async getCompanyServers() {
            // 这里应该调用接口获取服务器详情，目前先模拟数据
            let res = await request({
                url: "/company/api/getCompanyServers?companyId=" + this.serverId,
                method: 'GET'
            });
            if (res.data.status == 200) {
                this.serversList = res.data.data;
            }
        },
        handleClick() {

        },
        extractIPFromURL(url) {
            try {
                // 方法1：优先使用浏览器原生URL对象解析（兼容现代浏览器）
                const parsedUrl = new URL(url);
                const hostname = parsedUrl.hostname;

                // 如果是IPv6地址（如[2001:db8::1]），去除方括号
                if (hostname.startsWith('[') && hostname.endsWith(']')) {
                    return hostname.slice(1, -1);
                }

                // 如果是IPv4地址或域名，直接返回
                return hostname;
            } catch (e) {
                // 方法2：URL对象解析失败时，使用正则表达式作为兜底方案
                const ipv4Regex = /(?:\d{1,3}\.){3}\d{1,3}/; // 匹配IPv4
                const domainRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/i; // 匹配域名[1,4](@ref)

                // 尝试匹配IPv4
                const ipMatch = url.match(ipv4Regex);
                if (ipMatch) return ipMatch[0];

                // 尝试匹配域名
                const domainMatch = url.match(domainRegex);
                if (domainMatch && domainMatch[1]) {
                    return domainMatch[1].replace(/^www\./, ''); // 可选：去除www前缀
                }

                return null; // 均未匹配时返回null
            }
        },
        async getCompanyDetailByCompanyId() {
            // 这里应该调用接口获取服务器详情，目前先模拟数据
            let res = await request({
                url: "/company/api/getCompanyDetailByCompanyId?serverId=" + this.serverId,
                method: 'GET'
            });
            if (res.data.status == 200) {
                this.$nextTick(() => {
                    this.companyDetail = res.data.data;
                });
            }
        }
    }
}
</script>
